import cloneDeep from 'lodash/cloneDeep';
import apiService from 'src/utils/apiService';
import * as types from '../mutation-types';

// initial state
const state = {
  userNotifications: [],
};

// getters
const getters = {
};

// actions
const actions = {
  updateUserNotifications({ commit }, options = { dontShowErrors: false }) {
    return apiService.getUnreadUserNotifications(options.dontShowErrors).then((notifications) => {
      commit(types.UPDATE_USER_NOTIFICATIONS, notifications);
    });
  },
  removeUserNotifications({ commit }, notificationKey) {
    return apiService.removeUserNotification(notificationKey).then(() => {
      commit(types.REMOVE_USER_NOTIFICATION, notificationKey);
    });
  },
};

// mutations
const mutations = {
  [types.UPDATE_USER_NOTIFICATIONS](s, notifications) {
    s.userNotifications = cloneDeep(notifications); // eslint-disable-line
  },
  [types.REMOVE_USER_NOTIFICATION](s, notificationKey) {
    s.userNotifications = s.userNotifications.filter(n => n.notificationKey !== notificationKey); // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/userNotifications.js